module.exports = __webpack_public_path__ + "static/media/user-profile.69d2ed55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-profile.jpg
// module id = 535
// module chunks = 82